<template>
  <v-select
    hide-details="auto"
    :items="status"
    v-model="filterDatas.paymentStatus"
    item-text="name"
    item-value="id"
    label="Payment Status"
    outlined
    clearable
    dense
    @change="emitInput(filterDatas.paymentStatus)"
  ></v-select>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    status: [
      {
        id: 'paid',
        name: 'Paid',
      },
      {
        id: 'due',
        name: 'Due',
      },
    ],
    selectStatus: null,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_PAYMENT_STATUS_FILTER', data);

      this.$emit('input', this.filterDatas.paymentStatus);
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectStatus = null;
      },
      deep: true,
    },
  },
  created() {
    this.$emit('input', this.filterDatas.paymentStatus);
  },
};
</script>
